@import 'styles/mixins';
@import 'styles/variables';

.reviewMark {
  transition: background-color 250ms ease-out;

  &.selected {
    background-color: rgba($violet-60, 0.5);
  }
}
